import React from "react";
import { capitalizeFirstLetter, getClassName } from "@sscs/utils";
import { CopyIcon, IconButton, Toast, Tooltip } from "../";
import styles from "./copyHash.module.scss";
const CopyHash = ({ id, sha256, name = "hash", className }) => {
    return (React.createElement(Tooltip, { placement: "bottom", title: `Copy ${name.toLowerCase()} to clipboard` },
        React.createElement(IconButton, { id: id, size: "small", className: getClassName(styles.icon, className), onClick: async () => {
                await navigator.clipboard.writeText(sha256);
                Toast.show({
                    title: `${capitalizeFirstLetter(name)} copied successfully!`,
                    type: "success",
                });
            } },
            React.createElement(CopyIcon, { size: "xs" }))));
};
export default CopyHash;
//# sourceMappingURL=CopyHash.js.map